import React, { useEffect } from "react";
import useState from "react-usestateref";
import axios from 'axios';
import {
    Link,
    UNSAFE_enhanceManualRouteObjects,
    useNavigate,
} from "react-router-dom";


function DSAInterview() {

    const navigate = useNavigate();
    const [isProcessing, setisProcessing] = useState(false);
    const [interviewCreated, setinterviewCreated] = useState(false)
    const [problems, setproblems] = useState([])
    const [groupId, setgroupId] = useState(0)

    const createInterviewSessions = async () => {
        setisProcessing(true);
        const data = {
            company: "Google",
            user: "rhythmbatra"
        }
        const res = await axios.post('https://ed-tech-backend-eight.vercel.app/createinterviewsession/', data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        setisProcessing(false);
        setinterviewCreated(true)
        setproblems(res.data.problems)
        console.log("Problems After Creating : ", problems)
        setgroupId(res.data.groupId)
        console.log("Group Id After creating : ", groupId)
    };

    const navigateToInterview = (groupId, index) => {
        navigate("/interviewsession/" + groupId + "/" + index, {
            state: { groupId: groupId, problemId: index }
        })
    }


    return (
        <div>
            {interviewCreated ? <></> : <button onClick={() => createInterviewSessions()}>Generate Problems</button>}
            <br></br>
            {!interviewCreated && isProcessing && <>Spinner</>}
            {problems.map((r, index) => (
                <>
                    <button onClick={() => navigateToInterview(groupId, index)} key="{r}">{r}</button>
                    <br></br>
                </>
            ))}

            <div className="mt-10 bg-base-200">
                <div className="text-center">
                    <div className="w-full">
                        {
                            <div class="w-full p-8">
                                <div class="md:max-w-md mx-auto overflow-hidden rounded-3xl shadow-8xl">
                                    <div class="p-9">
                                        <span class="mb-7 inline-block text-sm text-gray-500 font-semibold uppercase tracking-px">
                                            Instructions :
                                        </span>
                                        <ul>
                                            <li class="mb-4 flex items-center">
                                                <svg
                                                    class="mr-2"
                                                    width="40"
                                                    height="20"
                                                    viewbox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                                                        stroke="#4F46E5"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                                <p class="font-semibold leading-normal">
                                                    You will get 15 Python questions to answer.
                                                </p>
                                            </li>
                                            <li class="mb-4 flex items-center">
                                                <svg
                                                    class="mr-2"
                                                    width="40"
                                                    height="20"
                                                    viewbox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                                                        stroke="#4F46E5"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                                <p class="font-semibold leading-normal"></p>The button
                                                for submitting answer will appear after 60 seconds of
                                                opening a question.
                                            </li>
                                            <li class="mb-4 flex items-center">
                                                <svg
                                                    class="mr-2"
                                                    width="40"
                                                    height="20"
                                                    viewbox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                                                        stroke="#4F46E5"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                                <p class="font-semibold leading-normal">
                                                    Click on the button labelled "Start Recording" to
                                                    record your answer.
                                                </p>
                                            </li>
                                            <li class="mb-4 flex items-center">
                                                <svg
                                                    class="mr-2"
                                                    width="60"
                                                    height="20"
                                                    viewbox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                                                        stroke="#4F46E5"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                                <p class="font-semibold leading-normal">
                                                    The recording will pause automatically after you stop
                                                    speaking. However, you can click on "Stop Recording"
                                                    button to stop the recording.
                                                </p>
                                            </li>
                                            <li class="mb-4 flex items-center">
                                                <svg
                                                    class="mr-2"
                                                    width="40"
                                                    height="20"
                                                    viewbox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.5 10L9.16667 11.6667L12.5 8.33333M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                                                        stroke="#4F46E5"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                                <p class="font-semibold leading-normal">
                                                    You will be redirected to your Interview Report page
                                                    as soon as you answer all the questions.
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="p-9">
                                        <div class="">
                                            <button
                                                class="py-4 px-5 w-full text-white font-semibold rounded-xl focus:ring focus:ring-indigo-300 bg-indigo-600 hover:bg-indigo-700 transition ease-in-out duration-200"
                                                type="button"

                                            >
                                                Start Interview
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DSAInterview